var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row title"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"micon",class:_vm.iconClass})]),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.name ? _vm.name : 'No Title :('))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }